import * as React from "react";
import { PropsWithChildren, useContext, useEffect, useState } from "react";
import type { Location } from "react-router";
import { useLocation } from "react-router-dom";

const PreviousLocationContext = React.createContext<Maybe<Location>>(null);

export const PreviousLocation: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState<Maybe<Location>>(null);
  const [currentLocation, setCurrentLocation] = useState<Maybe<Location>>(null);

  useEffect(() => {
    if (location.key !== currentLocation?.key) {
      setPrevLocation(currentLocation);
      setCurrentLocation(location);
    }
  }, [currentLocation, location]);

  return <PreviousLocationContext.Provider value={prevLocation}>{children}</PreviousLocationContext.Provider>;
};

export const usePreviousLocation: () => Maybe<Location> = () => {
  return useContext(PreviousLocationContext);
};
